import { Box, Button, Paper, TablePagination } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';
import SideBarContainer from 'Containers/SideBarContainer';
import { Padding } from 'Components/Padding';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import JobTitleCoursesKpis from './components/JobTitleCoursesKpis';
import JobTitleCoursesFilters from './components/JobTitleCoursesFilters';
import JobTitleCoursesGroupedList from './components/JobTitleCoursesGroupedList';
import useJobTitleCoursesReportPage from './hooks/useJobTitleCoursesReportPage';

/** Pantalla previa dentro de Definición de Cursos, a la que regresa el botón. */
const JOB_TITLES_SELECTION_ROUTE = '/definicion/seleccion/puesto';

const PAGE_SIZE_OPTIONS = [15, 25, 50];

/**
 * Reporte de Cursos por Puesto (MEX-466).
 *
 * Vista consolidada de los cursos definidos a nivel puesto: indicadores,
 * filtros combinables, lista agrupada por puesto (expandible) y export a Excel.
 * Se entra desde Definición de Cursos → Puestos y se regresa ahí con "Regresar".
 */
export default function JobTitleCoursesReportPage() {
  const history = useHistory();
  const {
    t2,
    filters,
    groups,
    kpis,
    pagination,
    loading,
    error,
    exporting,
    jobTitleOptions,
    categoryOptions,
    handleFiltersChange,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
  } = useJobTitleCoursesReportPage();

  // La pantalla de selección se protege exigiendo `isComingFrom`; sin este
  // state el "Regresar" rebotaría al índice de Definición de Cursos.
  const handleBack = () => history.push(JOB_TITLES_SELECTION_ROUTE, { isComingFrom: '/definicion' });

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('pageTitle') as string} accent={t2('pageAccent') as string} />}
        onExport={handleExport}
        buttons={
          <Button variant="outlined" color="inherit" startIcon={<ArrowBackIcon />} onClick={handleBack}>
            {t2('actions.back')}
          </Button>
        }
      />
      <Padding padding="1rem">
        <JobTitleCoursesFilters
          values={filters}
          onChange={handleFiltersChange}
          jobTitleOptions={jobTitleOptions}
          categoryOptions={categoryOptions}
        />
        <JobTitleCoursesKpis kpis={kpis} loading={loading} />
        <JobTitleCoursesGroupedList groups={groups} loading={loading || exporting} error={error} />

        {/* La paginación es por asignación curso-puesto, no por puesto: un
            puesto con muchos cursos puede continuar en la página siguiente,
            igual que el Reporte de Sesiones. */}
        {pagination && pagination.totalItems > 0 && (
          <Paper elevation={0} sx={{ mt: 1 }}>
            <Box display="flex" justifyContent="flex-end">
              <TablePagination
                component="div"
                count={pagination.totalItems}
                page={pagination.page - 1}
                rowsPerPage={pagination.pageSize}
                rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                onPageChange={(_, nextPage) => handlePageChange(nextPage + 1)}
                onRowsPerPageChange={event => handleRowsPerPageChange(Number(event.target.value))}
                labelRowsPerPage={t2('pagination.rowsPerPage') as string}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${t2('pagination.of')} ${count}`}
              />
            </Box>
          </Paper>
        )}
      </Padding>
    </SideBarContainer>
  );
}
